import "./lib/node-globals";
// 어떤 ResizeObserver 인스턴스보다 먼저 적용되도록 최상단에서 import (개발 오버레이의 양성 경고 차단)
import "./patch-resize-observer";

import "core-js/stable";
import "regenerator-runtime/runtime";
import "promise-polyfill/src/polyfill";

import "./cores/yup-extensions";

import React from "react";
import ReactDOM from "react-dom";

import "./lib";
import { i18init } from "./lib/i18n";

import Root from "./Root";
// import registerServiceWorker from "./registerServiceWorker";
import { store } from "./store";
import { hotjar } from "react-hotjar";
import getConfig from "./config";

// ResizeObserver의 양성(benign) 루프 경고("ResizeObserver loop ...")가 dev 에러 오버레이로 뜨는 것을 억제.
// ReactFlow 등에서 노드 크기를 측정할 때 발생하며 실제 동작에는 영향이 없다.
window.addEventListener("error", (event) => {
    if (event.message && event.message.includes("ResizeObserver loop")) {
        event.stopImmediatePropagation();
        event.preventDefault();
    }
});

async function run() {
    await i18init();
    ReactDOM.render(<Root store={store} />, document.getElementById("root"));
    const { hotjar_tracking_code } = getConfig;

    if (hotjar_tracking_code) hotjar.initialize(hotjar_tracking_code.hjid, hotjar_tracking_code.hjsv);
    // registerServiceWorker();
}

const loadedStates = ["complete", "loaded", "interactive"];

if (loadedStates.indexOf(document.readyState) !== -1 && document.body) {
    run();
} else {
    window.addEventListener("DOMContentLoaded", run, false);
}
